// import React, { useEffect } from "react";

// const ClickableIframe = ({ iframeSrc, redirectUrl }) => {
//   const handleClick = () => {
//     // Try multiple approaches for better cross-platform compatibility
//     try {
//       // First attempt: Try to open in new window/tab
//       const newWindow = window.open(redirectUrl, "_blank");

//       // If window.open fails or returns null (common in iOS), fall back to other methods
//       if (
//         !newWindow ||
//         newWindow.closed ||
//         typeof newWindow.closed === "undefined"
//       ) {
//         // Fallback 1: Create a temporary link element and trigger click
//         const link = document.createElement("a");
//         link.href = redirectUrl;
//         link.target = "_blank";
//         link.rel = "noopener noreferrer";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       }
//     } catch (error) {
//       // Fallback 2: If all else fails, try direct navigation
//       console.log("Fallback navigation triggered");
//       window.location.href = redirectUrl;
//     }
//   };

//   //   useEffect(() => {
//   //     window.scrollTo({ top: 0, behavior: 'smooth' });
//   //   }, []);

//   return (
//     <div className="bajaj-main-image" style={{ position: "relative" }}>
//       {/* The iframe */}
//       {/* <a href={redirectUrl} target="_blank" rel="noopener noreferrer"> */}
//       <iframe
//         src={iframeSrc}
//         className="new-iframe"
//         title="Clickable Iframe "
//         width="100%"
//         allowfullscreen
//         frameborder="0"
//         style={{ border: "none" }}
//         onLoad={() => window.scrollTo(0, 0)}
//       ></iframe>
//       {/* </a> */}

//       {/* Transparent overlay to catch clicks */}
//       <div
//         onClick={handleClick}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           cursor: "pointer",
//           backgroundColor: "transparent",
//           zIndex: 10,
//         }}
//       />
//     </div>
//   );
// };
// const BajajApp = () => {
//   return (
//     <ClickableIframe
//       iframeSrc="https://www.bajajbroking.in/widget/sandesh?utm_source=sandesh&utm_medium=plugins&utm_campaign=sandesh_widget_page"
//       redirectUrl="https://www.bajajbroking.in/open-demat-account?utm_source=sandesh&utm_medium=plugins&utm_campaign=open-demat-account"
//       width="100%"
//     />
//   );
// };

// export default BajajApp;

import React, { useEffect } from "react";

const BajajApp = () => {
  useEffect(() => {
    // Optional: Prevent scroll on body when iframe takes full screen
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <iframe
        src="https://www.bajajbroking.in/widget/sandesh?utm_source=sandesh&utm_medium=plugins&utm_campaign=sandesh_widget_page"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allowFullScreen
        title="Bajaj Widget"
      ></iframe>
    </div>
  );
};

export default BajajApp;
